import { Flex, Space } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MEDIA_QUERIES } from 'src/enums';
import useWindowDimensions from 'src/hooks/useWindowDimensions';
import { useTheme } from 'src/styles/theme';

import AppBottomModal from '../appBottomModal';
import AppCenterModal from '../appCenterModal';
import AppPrimaryButton from '../appPrimaryButton/AppPrimaryButton';
import classes from './style/DownloadAppModal.module.css';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IDownloadAppModalProps {
  visible: boolean;
  closeModal: () => void;
}

const DownloadAppModal: React.FunctionComponent<IDownloadAppModalProps> = (
  props
) => {
  // TOOLS
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const theme = useTheme();
  // PROPS
  const { visible, closeModal } = props;

  const handleOk = () => {
    window.open('https://apollo-qr.idgmc.org/', '_blank');
  };

  const renderContent = () => {
    return (
      <Flex
        justify="center"
        align="center"
        vertical
        className={classes.content}
      >
        <Space direction="vertical" size="middle" align="center">
          <img src="assets/apollo.png" />
          <p className={`${theme.fonts.classNames.cardTitle}`}>
            {t('downloadAppModal.title')}
          </p>
          <p className={`${theme.fonts.classNames.cardSubtitle}`}>
            {t('downloadAppModal.content')}
          </p>
          <AppPrimaryButton
            onClick={handleOk}
            className={`${classes.okButton}`}
          >
            {t('downloadAppModal.clickHereToDownload')}
          </AppPrimaryButton>
        </Space>
      </Flex>
    );
  };

  // get the modal type by the screen width
  const getModal = () => {
    if ((width ?? 0) < MEDIA_QUERIES.TABLET) {
      return (
        <AppBottomModal visible={visible} closeModal={closeModal}>
          {renderContent()}
        </AppBottomModal>
      );
    }
    return (
      <AppCenterModal visible={visible} closeModal={closeModal}>
        {renderContent()}
      </AppCenterModal>
    );
  };

  // VIEW
  return getModal();
};

export default DownloadAppModal;
